module.exports = __webpack_public_path__ + "staticindex/img/loginform1.28244570.png";